import React from "react";
import GoldButton from "../GoldButton";

const LinkColumn = ({ link, caption, content, flip, equal }) => {
    let sectionClass = flip ? 'image-column flip' : 'image-column';
    sectionClass = equal ? sectionClass + ' equal' : sectionClass;

    return (
        <section className={sectionClass}>
            <div className="container">
                {link && <div><GoldButton text={link.text} link={link.url} inNewTab={link.inNewTab} isGrey={link.isGrey} /></div>}
                {(caption || content) && <div>{caption && <h3>{caption}</h3>}{content && <p>{content}</p>}</div>}
            </div>
        </section>
    );
}

export default LinkColumn;